import { jwtDecode } from "jwt-decode";
import tokenService from "../services/TokenService";

export const getToken: () => boolean = () => {
  const accessTokenLocal = tokenService.getAccessToken();
  let exp: number = 0;
  let isValidToken: boolean = false;
  if (accessTokenLocal) {
    try {
      const decoded = jwtDecode(accessTokenLocal);
      if (decoded) {
        const expD = decoded.exp;
        if (expD) {
          exp = expD;
          const now = new Date().getTime() / 1000;
          if (now < exp) {
            isValidToken = true;
          } else {
            isValidToken = false;
          }
        } else {
          exp = 0;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  return isValidToken;
};